import { IdObj } from 'react-arborist/dist/module/types/utils';

export interface ITreeObj extends IdObj {
  pctegrySid: string;
  ctegrySid: string;
  ctegryNm: string;
  isOpen?: boolean;
  ctegryList: ITreeObjDir[];
  name: string;
  children: ITreeObjDir[];
}

export interface ITreeObjDir extends ITreeObj {
  isOpen?: boolean;
  children: ITreeObjDir[];
}

export type TreeObj = ITreeObjDir;

export const OrderEditType = {
  CATEGORY: 'category',
  BUSINESS: 'business',
} as const;

export type TOrderEditType = (typeof OrderEditType)[keyof typeof OrderEditType];
